//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '@/lib/util';
import {formatDate} from '../../../src/lib/date';

export default {
    name: 'order-details',
    components: {},
    filters: {
        formatDate(time, type) {
            var date = new Date(time);
            if (type == 1) {
                return formatDate(date, 'yyyy/MM/dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    data() {
        return {
            id: 0,
            orderDetail: {
                orderDetails: []
            },
            conttactInfor: {},
            shop: {},
            downloadUrl: util.ApiUrl + '/file/download/'
        };
    },
    methods: {
        init() {
            if (this.id === 0) {
                return;
            }
            this.getOrderDetail(this.id);
        },
        getOrderDetail(id) {
            abp.ajax.get('/api/services/app/Order/GetOrderById?id=' + id)
                .then(res => {
                    this.orderDetail = {};
                    this.orderDetail = res.data.result;
                    console.log('orderDetail：%@', res.data.result);
                    this.getConttactInfor(this.orderDetail.contactInformationId);
                    // this.getShop(this.orderDetail.shopId);
                });
        },
        getConttactInfor(id) {
            abp.ajax.get('/api/services/app/ContactInformation/GetContactInformationById?id=' + id)
                .then(res => {
                    this.conttactInfor = {};
                    this.conttactInfor = res.data.result;
                });
        },
        getShop(id) {
            abp.ajax.get('/api/services/app/Shop/GetShopById?id=' + id)
                .then(res => {
                    this.shop = {};
                    this.shop = res.data.result;
                });
        },
        clickPayBtn() {
            if (this.orderDetail.id === 0) {
                return;
            }
            this.$router.push({
                name: 'pay',
                params: {
                    id: this.orderDetail.id
                }
            });
        },
        complete() {
            // 收货完成订单
            var p = {
                id: this.$route.params.id,
                status: 3
            };
            abp.ajax.post('/api/services/app/Order/ChangeStatus', p)
                .then(res => {
                    console.log(res);
                    Toast.success('收货成功！');
                    this.init();
                })
                .catch((error) => {
                    console.log(error);
                    this.value = '';
                })
                .then(() => {
                });
        }
    },
    created() {
        this.id = parseInt(this.$route.params.id) || 0;
        this.init();
    },
    computed: {
        address() {
            let d;
            // console.log('11', this.conttactInfor);
            if (this.conttactInfor.areaName && this.conttactInfor.contactAddress) {
                d = this.conttactInfor.areaName + this.conttactInfor.contactAddress;
            }
            return d;
        }
    }
};
